import React, { useState, useEffect } from "react";
import TopLoader from "../Loader/TopLoader";
import login from "../../images/login.png";
import loginNew from "../../images/loginNew.png";
import logo from "../../images/logo192.png";
import logoNew from "../../images/logo2.png";
import { loginApi, get_master_role, get_role } from "../../api/Auth";
import $ from "jquery";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Languageoption from "../Language-Dropdown";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import { useForm } from "react-hook-form";
import { useRef } from "react";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { MDBTypography } from "mdb-react-ui-kit";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import { Modal } from "react-bootstrap";
import Navbar from "../Navbar/Navbar.jsx";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import bannerSvg from "../../images/shape3.svg";
import FiveTicon1 from "../../images/icon1.png";
import FiveTicon2 from "../../images/icon2.png";
import FiveTicon3 from "../../images/icon3.png";
import FiveTicon4 from "../../images/icon4.png";
import FiveTicon5 from "../../images/icon5.png";
import FiveTicon from "../../images/5t_logo.png";
import IAS from "../../images/IAS.png";
import Director from "../../images/director.png";
import CM from "../../images/cm.png";
import cabinetMT from "../../images/cbtMt.png";
// import Cookies from 'js-cookie';
import { TextField, TablePagination, Button } from "@mui/material";
import { Flex } from "antd";

const Login = ({ onChildData }) => {
  const myButtonRef = useRef(null);
  const { t } = useTranslation();
  const handleClick = (e) => {
    i18next.changeLanguage(e.target.value);
    localStorage.setItem("selectedLanguage", e.target.value);
  };
  // Use this to show error after forceful browsing
  const msg = localStorage.getItem("alert");
  useEffect(() => {
    if (msg) {
      toast.success(t(msg));
    }
    localStorage.removeItem("alert");
  }, [msg]);

  const [mobile, setMobile] = useState("");
  const [allMasterRole, setAllMasterRole] = useState("");
  const [masterRole, setMasterRole] = useState("");
  const [allRole, setAllRole] = useState("");
  const [role, setRole] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  const handleUpdateClick = () => {
    setModalOpen(true);
  };

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();

  useEffect(() => {
    const handleKeyPress = (event) => {
      if (event.key === "Enter") {
        myButtonRef.current.click(); // Trigger button click
      }
    };

    document.addEventListener("keydown", handleKeyPress);

    return () => {
      document.removeEventListener("keydown", handleKeyPress);
    };
  }, []); // Empty dependency array ensures the effect runs only once

  useEffect(() => {
    get_master_role()
      .then((res) => {
        if (res.status === "success") {
          console.log("dis data:", res.data);
          setAllMasterRole(res.data.master_role_data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
  }, []);

  const togglePassword = () => {
    if (!passwordVisible) {
      setPasswordVisible(true);
    } else {
      setPasswordVisible(false);
    }
  };

  let data = {
    mobile: mobile,
    password: password,
    role: role,
  };
  console.log("role", role);

  let navigate = useNavigate();

  function myfunction(e) {
    setMasterRole(e.target.value);

    let data = {
      master_role_order: e.target.value,
    };

    get_role(data)
      .then((res) => {
        if (res.status === "success") {
          setAllRole(res.data.role_data);
        }
      })
      .catch((err) => {
        console.error("Error fetching assets:", err);
      });
    console.log("role", role);
  }

  const handleRoleChange = (e) => {
    setRole(e.target.value);
  };

  function submitForm() {
    loginApi(data)
      .then((res) => {
        if (res.status === "failed") {
          toast.error(t(res.message));
        } else if (res.status === "success") {
          if (role == "admin") {
            setLoading(false);
            onChildData();
            navigate(`/dashboard`);
          } else if (role == 9) {
            setLoading(false);
            onChildData();
            navigate(`/myprofile`);
          } else if (role == 10) {
            setLoading(false);
            onChildData();
            navigate(`/studentprofile`);
          } else if (role == 14) {
            setLoading(false);
            onChildData();
            navigate(`/transfer-WEO`);
          } else if (role == 15) {
            setLoading(false);
            onChildData();
            navigate(`/transfer-headmaster`);
          } 
          else {
            setLoading(false);
            onChildData();
            navigate(`/dashboard`);
          }
        } else {
          toast.error(t("Something went wrong!"));
          console.log(res.error);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  $("input").on("keyup", function () {
    $(this).next("p.validation").hide();
  });

  return (
    <>
      <TopLoader loading={loading ? "50" : "100"} />
      {/* < Navbar/> */}
      <div
        className="mx-2"
        id="navBarLogin"
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          height: "6rem",
        }}
      >
        <img src={logoNew} alt="logo" style={{ height: "5rem" }} />
        <div style={{ marginLeft: "1rem", marginTop: "0.6rem" }}>
          <h3 style={{ fontSize: "20px ", lineHeight: "1" }}>
            Application for School & Hostel Review and Monitoring - ASHRAM
          </h3>
          <h4 style={{ color: "grey", fontWeight: "300", lineHeight: "1" }}>
            Government of Odisha
          </h4>
        </div>
      </div>
      <div
        className="col-md-12"
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "row",
          borderTop: "3px solid blue",
          borderBottom: "3px solid blue",
        }}
      >
        <div className="col-md-9" style={{ display: "flex" }}>
          <img src={loginNew} alt="loginNew" className="LoginImg" />
        </div>

        <div className="col-md-3" style={{ display: "flex" }}>
          <div className="loginForm">
            {/* <div className="text-center">
                <img className="text-center" src={logo} alt="logo" />
  </div>*/}
            <div
              className="text-center mt-2"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <AccountBalanceIcon />

              <h2
                style={{
                  marginLeft: "1rem",
                  marginBottom: "0",
                  fontSize: "24px",
                  fontStyle: "normal",
                  fontWeight: "700",
                  lineHeight: "29px",
                }}
              >
                ASHRAM Login
              </h2>
            </div>
            <form
              className="myform"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
              }}
            >
              <div className="form-outline mt-3">
                <label
                  className="form-label"
                  style={{ fontSize: "14px", fontWeight: "400" }}
                >
                  {t("Master Role")} <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="masterRole"
                  value={masterRole}
                  className="common-input form-select "
                  onChange={myfunction}
                  required
                  style={{ fontSize: "12.5px" }}
                >
                  <option value="" selected={true}>
                    {t("Select Master Role")}{" "}
                  </option>
                  {allMasterRole &&
                    allMasterRole.map((row, index) => (
                      <option value={row.master_role_order}>
                        {" "}
                        {row.master_role}
                      </option>
                    ))}
                </select>
                <span className="error-text">
                  {errors.role?.type === "required" && t("Role is required")}
                </span>
              </div>

              <div
                className="form-outline"
                style={{
                  marginTop: "10px",
                }}
              >
                <label className="form-label" style={{ fontSize: "14px" }}>
                  {t("Role")} <span style={{ color: "red" }}>*</span>
                </label>
                <select
                  name="role"
                  value={role}
                  onChange={handleRoleChange}
                  className="common-input form-select"
                  required
                  style={{ fontSize: "12.5px" }}
                >
                  <option value="" selected={true}>
                    {t("Select Role")}{" "}
                  </option>
                  {allRole &&
                    allRole.map((row, index) => (
                      <option value={row.id}> {row.role_name}</option>
                    ))}
                </select>
                <span className="error-text">
                  {errors.role?.type === "required" && t("Role is required")}
                </span>
              </div>

              <div className="form-outline">
                <label
                  className="form-label mt-2"
                  htmlFor="form2Example11"
                  style={{ fontSize: "14px" }}
                >
                  {t("Email or Mobile number")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  onChange={(e) => setMobile(e.target.value)}
                  style={{ fontSize: "12.5px" }}
                />
              </div>

              <div className="form-outline">
                <label
                  className="form-label mt-2"
                  htmlFor="form2Example22"
                  style={{ fontSize: "14px" }}
                >
                  {t("Password")}
                  <span style={{ color: "red" }}>*</span>
                </label>
                <div className="d-flex align-items-center">
                  <input
                    type={passwordVisible ? "text" : "password"}
                    className="form-control"
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ fontSize: "12.5px" }}
                  />
                  <span className="input-group-text" onClick={togglePassword}>
                    <i
                      className={`bi ${
                        passwordVisible ? "bi-eye-fill" : "bi-eye-slash-fill"
                      }`}
                    ></i>
                  </span>
                </div>
              </div>
              <div className="my-2" style={{ fontSize: "14px" }}>
                <Link
                  to="/forgotpassword"
                  style={{
                    color: "#102a83",
                    fontWeight: "500",
                  }}
                >
                  {t("Forgot Password?")}
                </Link>
              </div>

              <button
                ref={myButtonRef}
                disabled={mobile.length === 0 || password.length === 0}
                type="button"
                id="btn"
                className="form-control btn-block mt-2"
                onClick={submitForm}
              >
                {t("Login")}
              </button>
              <div
                className="mt-1"
                style={{
                  justifyContent: "center",
                  textAlign: "center",
                  color: "#102a83",
                  fontWeight: "600",
                }}
              >
                <p style={{ fontSize: "10px" }}>
                  *Note: Master Role and Role are mandatory fields
                </p>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        id="banner"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", flexDirection: "row" }}>
          
          {/* <img src={FiveTicon} alt="5T icon" style={{ height: "3rem" }} /> */}
          {/* <ul
            id="bannerUL"
            style={{
              display: "flex",
              flexDirection: "row",
              marginLeft: "1.6rem",
              position: "relative",
              top: "-2rem",
            }}
          >
            <li style={{ marginLeft: "0" }}>
              <img
                id="bannerIcons"
                src={FiveTicon1}
                alt="5Ticon1"
                style={{ height: "3.5rem" }}
              />
              <p id="Tlabel">Transparency</p>
            </li>
            <li>
              <img
                id="bannerIcons"
                src={FiveTicon2}
                alt="5Ticon2"
                style={{ height: "3.5rem" }}
              />
              <p id="Tlabel">Technology</p>
            </li>
            <li>
              <img
                id="bannerIcons"
                src={FiveTicon3}
                alt="5Ticon3"
                style={{ height: "3.5rem" }}
              />
              <p id="Tlabel">Teamwork</p>
            </li>
            <li>
              <img
                id="bannerIcons"
                src={FiveTicon4}
                alt="5Ticon4"
                style={{ height: "3.5rem" }}
              />
              <p id="Tlabel">Time</p>
            </li>
            <li>
              <img
                id="bannerIcons"
                src={FiveTicon5}
                alt="5Ticon5"
                style={{ height: "3.5rem" }}
              />
              <p id="Tlabel">Transformation</p>
            </li>
          </ul> */}
        </div>
        <div
          className="mt-4"
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "row",
          }}
        >
          <ul>
            <li
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
                marginRight: "9rem",
              }}
            >
              <img id="bannerIMGS" src={CM} alt="IAS" />
              <div
                className="mt-2 IMGtitle"
                style={{ color: "white", lineHeight: "1" }}
              >
                <h4>Shri Mohan Charan Majhi</h4>
                <p>Hon'ble Chief Minister</p>
              </div>
            </li>
          </ul>
          <ul>
            <li
              style={{
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "row",
              }}
            >
              <div
                className="mt-2 IMGtitle"
                style={{ color: "white", lineHeight: "1" }}
              >
                <h4>Shri Nityananda Gond</h4>
                <p>Hon'ble Cabinet Minister</p>
              </div>
              <img id="bannerIMGS" src={cabinetMT} alt="IAS" />
            </li>
          </ul>
        </div>
      </div>

      <div
        className="footer"
        style={{
          height: "6rem",
        }}
      ></div>
    </>
  );
};

export default Login;
